import Vue from 'vue';
import app from '../../public-api';
import { createId } from '../../../../shared/util';
import IqIndicator from './IqIndicator';
import { getVueI18n } from '../../../../shared/services/I18nService';

app.plugins.register({
  name: 'us:image-quality-indicator',

  extends: 'viewport',

  constructor (uScope, viewport) {
    const indicator = document.createElement('div');
    indicator.id = createId();
    viewport.vpDivGet('outer').append(indicator);
    return new Vue({
      el: `#${indicator.id}`,
      i18n: getVueI18n(),
      render: (h) => h(IqIndicator)
    });
  }
});



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/image-quality-indicator/index.js